import React from "react";
import FormattedNumber from "@/shared/components/FormattedNumber";
import { TreemapBar, TreemapSegment, TreemapLabel } from "./styledComponents";

function TreemapSection({ items, wallet }) {
  const total = items.reduce((sum, a) => sum + (a.balance <= 0 ? 0 : a.balance), 0) || 1;

  return (
    <div style={{ marginTop: "16px" }}>
      <h4 style={{ fontSize: "13px", color: "#94a3b8", margin: "0 0 6px", fontWeight: 600 }}>
        {wallet} Wallet · Allocation Treemap
      </h4>
      <TreemapBar>
        {items.map((a) => {
          const value = a.balance <= 0 ? 0.0001 : a.balance;
          const width = (value / total) * 100;
          return (
            <TreemapSegment key={`${wallet}-${a.symbol}-seg`} width={width}>
              <TreemapLabel>
                {a.symbol} · <FormattedNumber value={a.balance || 0} symbol="$" maxDecimals={2} />
              </TreemapLabel>
            </TreemapSegment>
          );
        })}
      </TreemapBar>
    </div>
  );
}

export default TreemapSection;

